// extracted by mini-css-extract-plugin
module.exports = {"reactionTooltip":"ReactionsTooltip_reactionTooltip__YTDuy","arrow":"ReactionsTooltip_arrow__XtF2I"};